import { withPrefix } from "gatsby";
import Default from "../../../../src/gatsby-theme-carbon/templates/Default";
import { TkFooter } from "../../../../src/components/toolkit/TkFooter";
import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';
import spaceship from "../../../../src/images/spaceship.svg";
import touchScreen from "../../../../src/images/touch--screen.svg";
import build from "../../../../src/images/build.svg";
import expandVert from "../../../../src/images/expand--vert.svg";
import calendar from "../../../../src/images/calendar.svg";
import magNode from "../../../../src/images/npm.svg";
import magKarma from "../../../../src/images/karma.svg";
import magFirefox from "../../../../src/images/firefox.svg";
import magChrome from "../../../../src/images/chrome.png";
import github from "../../../../src/images/github.svg";
import model from "../../../../src/images/model.svg";
import figma from "../../../../src/images/figma.svg";
import video02 from "../../../../src/images/video02.svg";
import report from "../../../../src/images/report.svg";
import ToolkitBanner from "../../../../src/images/ToolkitBanner.svg";
import launch from "../../../../src/images/launch.svg";
import locked from "../../../../src/images/locked.svg";
import ArrowRight16 from '@carbon/icons-react/lib/arrow--right/16';
import ibmLogo from "../../../../src/images/ibm_logo.svg";
import { Video } from 'gatsby-theme-carbon/src/components/Video';
import "../../../../src/pages/toolkit/toolkit-home.scss";
import "../../../../src/pages/toolkit/toolkit-resource-cards.scss";
import keyboard from "../../../../src/images/keyboard.svg";
import clipboard from "../../../../src/images/clipboard.svg";
import * as React from 'react';
export default {
  withPrefix,
  Default,
  TkFooter,
  Row,
  Column,
  spaceship,
  touchScreen,
  build,
  expandVert,
  calendar,
  magNode,
  magKarma,
  magFirefox,
  magChrome,
  github,
  model,
  figma,
  video02,
  report,
  ToolkitBanner,
  launch,
  locked,
  ArrowRight16,
  ibmLogo,
  Video,
  keyboard,
  clipboard,
  React
};